import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientStatisticsByMonth } from '@classes/client-statistics/client-statistics-by-month';
import { ClientStatisticsByMonthRequest } from '@classes/client-statistics/client-statistics-by-month-request';
import { ClientStatisticsByYear } from '@classes/client-statistics/client-statistics-by-year';
import { ClientStatisticsByYearRequest } from '@classes/client-statistics/client-statistics-by-year-request';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientStatisticsService {

  private baseUrl: string = environment.apiUrl + 'client-statistics';

  constructor(
    private _httpClient: HttpClient,
  ) { }

  public getByMonth$(clientStatisticByMonthRequest: ClientStatisticsByMonthRequest): Observable<ClientStatisticsByMonth> {
    return this._httpClient
      .post<ClientStatisticsByMonth>(
        `${this.baseUrl}/by-month`,
        clientStatisticByMonthRequest
      );
  }

  public getByYear$(clientStatisticsByYearRequest: ClientStatisticsByYearRequest): Observable<ClientStatisticsByYear[]> {
    return this._httpClient
      .post<ClientStatisticsByYear[]>(
        `${this.baseUrl}/by-year`,
        clientStatisticsByYearRequest
      );
  }
}
